export const reducerTypes = {
  GET_HOME_PRODUCTS: 'reducer/GET_HOME_PRODUCTS',
  GET_ALL_PRODUCTS: 'reducer/GET_ALL_PRODUCTS',
  GET_MORE_PRODUCTS: 'reducer/GET_MORE_PRODUCTS',
  GET_ALSO_LIKED_PRODUCTS: 'reducer/GET_ALSO_LIKED_PRODUCTS',
  SET_SORTING: 'reducer/SET_SORTING',
  SET_PRICE_RANGE: 'reducer/SET_PRICE_RANGE',
  SET_PAGE_INFO: 'reducer/SET_PAGE_INFO',
  SET_PAGE_INDEX: 'reducer/SET_PAGE_INDEX',
  SET_PAGE_SIZE: 'reducer/SET_PAGE_SIZE',
  GET_PRODUCT: 'reducer/GET_PRODUCT',
  IS_LOADING: 'reducer/LOADING_TRUE',
  GET_FILTERS: 'reducer/GET_FILTERS',
  GET_INITIAL_FILTERS: 'reducer/GET_INITIAL_FILTERS',
  GET_FAVORITES: 'reducer/GET_FAVORITES',
  GET_COMPARE: 'reducer/GET_COMPARE',
  GET_SUGGESTION: 'reducer/GET_SUGGESTION',
  SET_SELECTED_PRODUCTS: 'reducer/SET_SELECTED_PRODUCTS',
  SET_SELECTED_COLLECTION_TABLE: 'reducer/SET_SELECTED_COLLECTION_TABLE',
};

export const sagaTypes = {
  GET_HOME_PRODUCTS: 'saga/GET_HOME_PRODUCTS',
  GET_ALL_PRODUCTS: 'saga/GET_ALL_PRODUCTS',
  GET_MORE_PRODUCTS: 'saga/GET_MORE_PRODUCTS',
  GET_NEW_ARRIVALS: 'saga/GET_GET_NEW_ARRIVALS',
  GET_MORE_NEW_ARRIVALS: 'saga/GET_MORE_NEW_ARRIVALS',
  GET_ALSO_LIKED_PRODUCTS: 'saga/GET_ALSO_LIKED_PRODUCTS',
  GET_FILTERED_PRODUCTS: 'saga/GET_FILTERED_PRODUCTS',
  GET_MORE_FILTERED_PRODUCTS: 'saga/GET_MORE_FILTERED_PRODUCTS',
  GET_PRODUCT: 'saga/GET_PRODUCT',
  GET_PRODUCT_BY_ID: 'saga/GET_PRODUCT_BY_ID',
  GET_FILTERS: 'saga/GET_FILTERS',
  GET_COLLECTIONS_FILTERS: 'saga/GET_COLLECTIONS_FILTERS',
};
